<!-- 资源占用 -->
<template>
  <div class="new-application">
    <el-card class="box-card">
      <div class="content-title">
        <span class="title-icon"></span>
        <span class="title-details">基本信息</span>
      </div>
      <div>
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :showBtn="false"
          :disabled="isShow"
          :loading="loading"
          @submit="submit(2)"
          @cancelForm="cancel"
        >
          <div>
            <!-- <div style="margin-left: 50px">{{item.person}}</div> -->
            <el-calendar style="width:80%;margin:0 auto" v-model="month">
              <template
                slot="dateCell"
                slot-scope="{date, data}"
              >
                <div
                  style="width:100%;height:100%;font-size: 14px"
                  @click="pick(date)"
                  :style="dateStyle(data.day)"
                >
                  {{ data.day.split('-').slice(1).join('-') }}<br /> {{dealMyDate(data.day)}}
                </div>
              </template>
            </el-calendar>
          </div>
        </dynamic-form>
      </div>
      <div class="button">
        <el-button class="btn-submit" :loading="loading" @click="submit(2)">提交</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import "@/components/dynamic-form";
import {
  addApplication,
  updateApplication,
  getPersonAccount,
  getProjectRoles,
  getResourceDetail
} from "@/api/bill/resource";
import { parseTime } from "@/utils";
import { getDocumentCode } from "@/views/utils";

export default {
  name: "ResourceAccount",

  data() {
    return {
      id: "",
      isShow: false,
      loading: false,
      form: {projectRole: {}},
      formConfig: {
        formItemList: [
          {
            span: 8,
            label: "单据编号",
            key: "documentNumber",
            type: "input",
            disabled: true
          },
          {
            label: "人员",
            key: "person",
            type: "databox",
            placeholder: "请选择人员",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            label: "项目名",
            key: "project",
            type: "databox",
            placeholder: "请选择项目",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/resourceApply/getProject",
            tableColumn: [
              {
                property: "code",
                label: "项目号",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: {},
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            label: "项目角色",
            key: "projectRole",
            type: "databox",
            placeholder: "请选择项目角色",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bsProjectRoles",
            tableColumn: [
              {
                property: "code",
                label: "项目角色",
                align: "center"
              },
              {
                property: "name",
                label: "角色名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            label: "占用天数",
            key: "applyDay",
            type: "input",
            span: 8,
            disabled: true
          }
          //  {
          //   type: "calendar",
          //   key: "calendar",
          //   label: "",
          //   value: "",
          //   span: 20,
          // },
        ]
      },
      // 状态
      status: 0,
      personId: "",
      projectId: "",
      resDate: [], // 已被占用数组
      selectDate: [], // 新增占用数组
      month: parseTime(new Date(), "{y}-{m}")
    };
  },
  created() {
    console.log('query...',this.$route.query)
    this.isShow = Boolean(Number(this.$route.query.isShow));
    if (!this.isShow) {
      this.form.documentNumber = getDocumentCode("ZYSQ");
    } else {
      this.id = this.$route.query.id;
      this.personId = this.$route.query.personId
     getResourceDetail(this.id).then(res => {
        this.personId = res.data.resourceApply.personId;
        this.form.documentNumber = res.data.resourceApply.documentNumber;
        this.form.project = { code: res.data.resourceApply.projectId, name: res.data.resourceApply.projectName };
        this.form.person = { id: res.data.resourceApply.personId, name: res.data.resourceApply.personName };
        this.form.projectRole = { code: res.data.resourceApply.projectRoles,  name: res.data.resourceApply.projectRolesName};
        this.form.applyDay = res.data.resourceApply.applyDay;
        // for (const i of res.data.detailsVos) {
        //   this.resDate.push({  applyId: i.applyId,  id: i.id,  occupyDate: i.occupyDate,  projectName: i.projectName,  state: i.state});
        //   }
      })
      getPersonAccount(this.personId, { month: this.month }).then(res => { // 获取占用列表
          for (const i of res.data) {
            this.resDate.push({ applyId: i.applyId, id: i.id, occupyDate: i.occupyDate,  projectName: i.projectName,  state: i.state });
          }
        });
      this.isShow = true;
      console.log(this.resDate)
    }
  },
  computed: {},
  watch: {
    month(newVal, oldVal) {
      this.month =  parseTime(newVal, "{y}-{m}")
      // debugger
      if (newVal && !this.id && parseTime(newVal, "{y}-{m}") !== parseTime(oldVal, "{y}-{m}")) {
        // this.resDate = [];
        getPersonAccount(this.personId, { month: this.month }).then(res => { // 获取占用列表
          for (const i of res.data) {
            this.resDate.push({ applyId: i.applyId, id: i.id, occupyDate: i.occupyDate,  projectName: i.projectName,  state: i.state });
          }
        });
      }
    },
    "form.person": {
      handler(val,oldVal) {
          if (val && val !== oldVal && !this.id) {
             this.personId = val.id;
              this.resDate = []; // 人切换时数据清空
              this.selectDate = []
              this.form.applyDay = 0;
            getPersonAccount(val.id, { month: this.month }).then(res => {
              for (const i of res.data) {
              this.resDate.push({  applyId: i.applyId,  id: i.id, occupyDate: i.occupyDate, projectName: i.projectName, state: i.state });
              }
            });
             getProjectRoles(this.personId, { projectId: this.projectId }).then(res => { // 获取项目角色
            if (res.code ===  200 && res.data) {
              this.$set(this.form,'projectRole',{ code: res.data.projectRoles, name: res.data.projectRolesName,id: res.data.projectRoles})
              } else {
                this.$set(this.form,'projectRole',{})
                }
              });
          }
      },
      deep: true
    },
    "form.project": {
      handler(val,oldVal) {
        console.log(val)
        if (val) {
          this.projectId = val.id;
          if (this.personId && this.projectId && val !== oldVal) {
             this.selectDate = [] // 切换项目清空之前选择的数据
             this.form.applyDay = 0;
             this.resDate  = this.resDate.filter(item => { return item.id })
            getProjectRoles(this.personId, { projectId: this.projectId }).then(res => {
              if (res.code ===  200 && res.data) {
                  //  this.form.projectRole = { code: res.data.projectRoles, name: res.data.projectRolesName };
                  this.$set(this.form,'projectRole',{ code: res.data.projectRoles, name: res.data.projectRolesName,id: res.data.projectRoles})
                } else {
                  this.$set(this.form,'projectRole',{})
                }
                });
          }
        }
      },
      deep: true
    }
  },
  methods: {
    // 日历选中
    pick(data) {
       const curDate = parseTime(data, "{y}-{m}-{d}");
      // const now = parseTime(new Date(), "{y}-{m}-{d}");
      // if (Date.parse(curDate.replace(/\-/g,'/')) < Date.parse(now.replace(/\-/g,'/')) && !this.id) {
      //   this.$notify({ title: "今天之前的日期不可以选择！", type: "error", duration: 2500 });
      // } else {
        for (let i = 0; i < this.resDate.length; i++) {
          // state:0 占用中 1 已占用 2 释放中 3 已释放 4 无
          if (this.selectDate.length > 0) {
            for (let o = 0; o < this.selectDate.length; o++) {
              if (this.resDate[i].occupyDate === this.selectDate[o].occupyDate && (this.selectDate[o].occupyDate === curDate)) {
                this.selectDate.splice(o,1)
                this.resDate.splice(i,1)
                this.form.applyDay = this.selectDate.length
                return
                }
            }
          }
          if (!this.id && this.resDate[i].occupyDate === curDate && (this.resDate[i].state === 0 || this.resDate[i].state === 1 || this.resDate[i].state === 2)) {
            return this.$notify({
              title: "当天还没有被释放，不可选择！",
              type: "error",
              duration: 2500
            });
          }
        }
         const index = this.selectDate.findIndex(item => { return item.occupyDate === curDate; });
        if (index === -1 && this.projectId && this.personId) {
          this.selectDate.push({ occupyDate: curDate, projectName: this.form.project.name, state: 0 });
          this.resDate.push({ occupyDate: curDate, projectName: this.form.project.name, state: 0 });
        }
        if (index === -1 && !this.projectId && !this.id) {
           return this.$notify({ title: "请先选择项目！", type: "error", duration: 2500 });
        }
        if (index === -1 && !this.personId && !this.id) {
           return this.$notify({ title: "请先选择人员！", type: "error", duration: 2500 });
        }
        if (!this.id) {
          this.form.applyDay = this.selectDate.length
        }
      // }
    },
    // 日历样式
    dateStyle(date) {
      // background:#FF69B4;color:#ffffff
      let background = ''
      for (const i of this.resDate) {
        // state:0 占用中 1 已占用 2 释放中 3 已释放 4 无
         if (i.occupyDate === date && i.state === 1) {
          background = "background:#FF69B4;color:#ffffff"
        }
        if (this.id && i.occupyDate === date && i.state === 1 && i.applyId === this.id) { // 本单据的占用颜色显示
          background = "background:	#DC143C;color:#ffffff"
        }
      }
      return background;
    },
    // 日历展示的内容
    dealMyDate(v) {
      let res = "";
      for (const i of this.resDate) {
        // state:0 占用中 1 已占用 2 释放中 3 已释放 4 无
        if (i.occupyDate === v && i.state === 0) {
          res = i.projectName + "√";
        } else if (i.occupyDate === v && i.state === 1) {
          res = i.projectName;
        } else if (i.occupyDate === v && i.state === 2) {
          res = i.projectName + "×";
        } else if (i.occupyDate === v && i.state === 3) {
          res = i.projectName + "○";
        } else if (i.occupyDate === v && i.state === 4) {
          res = i.projectName;
        }
      }
      return res;
    },
    submit(status) {
      console.log(this.form)
      this.loading = true;
      this.form.billState = status;
      this.form.personId = this.form.person.id;
      this.form.projectId = this.form.project.id;
      this.form.projectRoles = this.form.projectRole.id;
      this.form.applyDay = this.selectDate.length;
      const obj = {};
      obj.resourceApply = this.form;
      obj.resourceApplyDetails = this.selectDate;
      console.log(obj);
      if (!this.form.projectRoles) {
        return this.$notify({ title: "请选择项目角色~", type: "error", duration: 2500 });
      }
      if (obj.resourceApplyDetails.length <= 0 || !this.form.personId || !this.form.projectId) {
        return this.$notify({ title: "数据不全~", type: "error",  duration: 2500 });
      }
      console.log(this.form)
      this.pull(obj);
    },
    cancel() {
      this.$router.go(-1);
    },
    pull(data) {
      if (this.id) {
        updateApplication(data).then(res => {
          if (res.code === 200) {
            this.loading = false;
            this.$notify({
              title: "提交成功！",
              type: "success",
              duration: 2500
            });
            this.$router.go(-1);
          }
        });
      } else {
        addApplication(data).then(res => {
          this.loading = false;
          if (res.code === 200) {
            this.$notify({
              title: "提交成功！",
              type: "success",
              duration: 2500
            });
             this.$router.go(-1);
          }
        });
      }
      // setTimeout(() => { this.cancel() },3000)
    }
  }
};
</script>

<style lang="scss" scoped>
.content-title {
  height: 40px;
  background-color: #e7eff6;
  padding-left: 20px;
  overflow: hidden;
  .title-icon {
    display: inline-block;
    margin-top: 8px;
    width: 4px;
    height: 24px;
    background-color: #1369a8;
    margin-right: 14px;
  }
  .title-details {
    overflow: hidden;
    line-height: 20px;
    display: inline-block;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    font-family: SourceHanSansSC-regular;
  }
}
.el-icon-back {
  padding-bottom: 10px;
}
.button {
      padding-top: 20px;
      text-align: right;

      .btn-submit {
        width: 80px;
        height: 38px;
        background: #1369a8;
        color: white;
      }

      .btn-cancel {
        width: 80px;
        height: 38px;
        background: #fff;
      }
    }
</style>
